import { Image } from '@repo/ui/Image';
import { FC } from 'react';

import { MICROCOPY } from '@/data/microcopy/microcopyDictionary';
import { Button } from '@/general/components/Button/Button';
import {
    ConfirmationFormValues,
    PersonalizedQuoteFormProps,
} from '@/personalised-quote/templates/Forms/PersonalizedQuoteForm.type';
import { getMicrocopy } from '@/stores/microcopyStore';

import styles from './PersonalizedQuoteForm.module.scss';

export const Confirmation: FC<PersonalizedQuoteFormProps<ConfirmationFormValues>> = () => {
  const content = MICROCOPY.PERSONALIZED_QUOTE_CONFIRMATION_DESCRIPTION;

  return (
    <section className={styles.confirmation}>
      <div className={styles.imageContainer}>
        <Image
          src="/images/components/PersonalizedQuoteStep9ConfirmationPage/Computer.svg"
          width={160}
          height={160}
          alt=""
        />
      </div>
      <div className={styles.contentContainer} data-testid="PERSONALIZED_QUOTE_CONFIRMATION_TITLE">
        {getMicrocopy(content, true)}
      </div>
      <div className={styles.buttonContainer}>
        <Button variant="primary" fullWidth href="/account/finance-quotes" data-testid="submit">
          {getMicrocopy(MICROCOPY.PERSONALIZED_QUOTE_CONFIRMATION_BUTTON_LABEL)}
        </Button>
      </div>
    </section>
  );
};
